var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c50532;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.066 8.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.067)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.912,0a.385.385,0,0,0-.385.385V1.793a4.99,4.99,0,0,0-8.46,3.6.385.385,0,1,0,.769,0,4.229,4.229,0,0,1,7.351-2.861l-1.7.569a.386.386,0,0,0,.243.732l2.307-.771A.385.385,0,0,0,26.3,2.7V.385A.385.385,0,0,0,25.912,0Z",
    transform: "translate(-17.067)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.837 4.935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.043,221.867a.385.385,0,0,0-.385.385,4.229,4.229,0,0,1-7.351,2.861l1.7-.569a.386.386,0,0,0-.243-.732l-2.307.77a.385.385,0,0,0-.263.367v2.312a.385.385,0,1,0,.769,0v-1.407a4.99,4.99,0,0,0,8.46-3.6A.385.385,0,0,0,60.043,221.867Z",
    transform: "translate(-51.198 -221.867)"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16,
    transform: "translate(6 6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/Icon_Refresh.6c507e6fde3bbdae323b8e689eab4a4a.svg";
export { ForwardRef as ReactComponent };